<template>
  <fieldset :data-fieldset="name" :disabled="disabled">
    <legend>
      <span>{{ label }}</span>
    </legend>
    <div class="wrapper">
      <div class="label" :data-label="label"></div>
      <div class="content">
        <slot></slot>
      </div>
    </div>
  </fieldset>
</template>

<script>
export default {
  name: 'FilterFieldset',
  props: {
    name: {
      type: String,
      required: false,
      default: ''
    },
    label: {
      type: String,
      required: false,
      default: ''
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    }
  }
}
</script>

<style scoped>
fieldset {
  @mixin type-smaller;
  @mixin type-medium-lineheight;
}
fieldset[disabled] {
  opacity: 0.4;
  pointer-events: none;
}
.wrapper {
  position: relative;
  display: flex;
  vertical-align: baseline;
}
.label {
  flex: 0 0 var(--filter-label-width);
  @mixin type-smaller;
  @mixin type-medium-lineheight;
  vertical-align: baseline;
  &::before {
    content: attr(data-label);
  }
}
.content {
  flex: 0 0 calc(100% - var(--filter-label-width));
}
legend span {
  @mixin hide-visually;
}
</style>
